import Avatar from "react-avatar";
import PropTypes from "prop-types";
import { UilUserCircle } from "@iconscout/react-unicons";

const Avatars = (props) => {
  const { type = "active", size = "small", name = "Alvin Lianto", color = "#1F4BFF" } = props;

  if (type === "active") {
    return (
      <Avatar
        name={name}
        size={size === "large" ? "128" : size === "medium" ? "64" : "32"}
        value="."
        round="100%"
        color={color}
        alt="Hub"
      />
    );
  } else {
    return (
      <div
        className={`rounded-full bg-gray-culture flex justify-center items-center ${
          size === "large" ? "w-32 h-32" : size === "medium" ? "w-16 h-16" : "w-8 h-8"
        }`}
      >
        <UilUserCircle size={size === "large" ? "128" : size === "medium" ? "64" : "32"} color="#8F8F8F" />
      </div>
    );
  }
};

Avatars.propTypes = {
  type: PropTypes.string,
  size: PropTypes.string,
  name: PropTypes.string,
  color: PropTypes.string,
};

export default Avatars;
